import type { DiagramType } from '../../lib/diagram/registries';
import type { DomainDataProfile } from './DomainDataProfile';

type AnyDomainProfile = DomainDataProfile<any, any, any, any>;

const profileRegistry = new Map<string, AnyDomainProfile>();

export function registerDomainProfile(profile: AnyDomainProfile): void {
  if (profileRegistry.has(profile.domainId)) {
    return;
  }
  profileRegistry.set(profile.domainId, profile);
}

export function listDomainProfiles(): AnyDomainProfile[] {
  return Array.from(profileRegistry.values());
}

export function getDomainProfile(domainId: string): AnyDomainProfile | null {
  return profileRegistry.get(domainId) ?? null;
}

export function getProfileForDiagramType(diagramType: DiagramType): AnyDomainProfile | null {
  for (const profile of profileRegistry.values()) {
    if (profile.diagramTypes.includes(diagramType)) {
      return profile;
    }
  }
  return null;
}

export function resetProfileRegistry(): void {
  profileRegistry.clear();
}
